import React, { Component } from 'react';
import ReactGA from 'react-ga';
import './verify_email.css';

class VerifyEmail extends Component {
    
    render() {
        ReactGA.pageview('/verify-email');
        return (<div className="email-body" >
            {/*
            <img src="/images/logo.png"
                alt="logo"
                className="image" />
            */}

            <h1 className="signup_title"> Please verify your email </h1>
            <p className="signup_title"> You are one step away from your first discussion. </p>
            <p className="signup_subtitle" > A verification email has been sent to your account. <br/>Please check your email to complete your signup. </p> </div>
        );
    }
}

export default VerifyEmail;